import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    details: null,
    verification: null,
    courses: [],
    periods: [],
    teachingPlans: [],
    school: null,
    settings: null,
}

export const teacherAccountSlice = createSlice({
    name: 'teacherAccount',
    initialState,
    reducers: {
        updateTeacherAccount: (state, action) => {
            state.details = action.payload?.details ? action.payload?.details : state.details;
            state.verification = action.payload?.verification ? action.payload?.verification : state.verification;
            state.courses = action.payload?.courses ? action.payload?.courses : state.courses;
            state.periods = action.payload?.periods ? action.payload?.periods : state.periods;
            state.teachingPlans = action.payload?.teachingPlans ? action.payload?.teachingPlans : state.teachingPlans;
            state.school = action.payload?.school ? action.payload?.school : state.school;
            state.settings = action.payload?.settings ? action.payload?.settings : state.settings;
            console.log('Updated teacher account state:', {
                details: state.details,
                courses: state.courses,
                periods: state.periods,
                teachingPlans: state.teachingPlans,
                school: state.school,
                settings: state.settings
            });
        },
        updateTeacherDetails: (state, action) => {
            console.log('saving teacher details to redux');
            state.details = action.payload;
        },
        updateTeacherVerification: (state, action) => {
            console.log('saving teacher verification to redux');
            state.verification = action.payload;
        },
        updateTeacherCourses: (state, action) => {
            console.log('saving teacher courses to redux');
            console.log(action.payload);
            state.courses = action.payload;
        },
        updateTeacherPeriods: (state, action) => {
            console.log('saving teacher periods to redux');
            if (Array.isArray(action.payload)) {
                state.periods = action.payload;
            } else {
                const existingPeriodIndex = state.periods.findIndex(period => period.id === action.payload.id);
                if (existingPeriodIndex >= 0) {
                    state.periods[existingPeriodIndex] = action.payload;
                } else {
                    state.periods = [...state.periods, action.payload];
                }
            }
            console.log('updated periods', state.periods);
        },
        updateTeacherTeachingPlans: (state, action) => {
            console.log('saving teacher teaching plans to redux');
            if (Array.isArray(action.payload)) {
                state.teachingPlans = action.payload;
            } else {
                const existingTeachingPlanIndex = state.teachingPlans.findIndex(teachingPlan => teachingPlan.id === action.payload.id);
                if (existingTeachingPlanIndex >= 0) {
                    state.teachingPlans[existingTeachingPlanIndex] = action.payload;
                } else {
                    state.teachingPlans = [...state.teachingPlans, action.payload];
                }
            }
        },
        updateTeacherSchool: (state, action) => {
            console.log('saving teacher school to redux');
            state.school = action.payload;
        },
        updateTeacherCourseData: (state, action) => {
            console.log(`saving teacher course data to redux for course ${action.payload.courseId}`);
            const courseData = state.courses.find(course => course.id === action.payload.courseId);
            state.courses = state.courses.map(
                course => course.id === action.payload.courseId ? { ...courseData, ...action.payload.data } : course
            );
        },
        updateTeacherSettings: (state, action) => {
            console.log('saving teacher settings to redux');
            state.settings = action.payload;
        },
        clearTeacherAccount: (state) => {
            state.details = null;
            state.courses = null;
            state.settings = null;
            state.school = null;
            state.verification = null;
            state.periods = [];
            state.teachingPlans = [];
        },
        updateTeacherCourseProperty: (state, action) => {
            const { courseId, property, value } = action.payload;
            state.courses = state.courses.map(course =>
                course.id === courseId
                    ? { ...course, [property]: value }
                    : course
            );
        }
    }
});

export const {
    updateTeacherAccount,
    updateTeacherDetails,
    updateTeacherVerification,
    updateTeacherCourses,
    updateTeacherSchool,
    updateTeacherCourseData,
    updateTeacherSettings,
    updateTeacherTeachingPlans,
    updateTeacherPeriods,
    clearTeacherAccount,
    updateTeacherCourseProperty
} = teacherAccountSlice.actions;

export default teacherAccountSlice.reducer;
